import { Outlet } from 'react-router-dom';
import { useReferralQuery } from './useReferralQuery';

export function ReferralQueryRoot() {
  useReferralQuery();
  return <Outlet />;
}
